import React from 'react';
import { XIcon } from 'lucide-react';
import { painClaim, painClose, painHeadline, painIntro, painPoints } from '../data/content';
export function PainPoints() {
  return <section className="bg-night-panel" data-id="element-158" data-mp="26yfs1jcmjdn6">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" style={{
      paddingTop: "0px"
    }} data-id="element-159" data-mp="26xehdfzist5z">
        <h2 className="mx-auto max-w-3xl text-center font-display text-[1.75rem] font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" style={{
        paddingTop: "24px"
      }} data-id="element-160" data-mp="2bw7uv8et4k65">
          {painHeadline}
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-center font-sans text-base leading-relaxed text-parchment/75 sm:text-lg" data-id="element-161" data-mp="220o22uvji1lm">
          {painIntro}
        </p>

        <ul className="mx-auto mt-8 grid max-w-4xl gap-3 md:grid-cols-2" data-id="element-162" data-mp="1sxv98n6plhto">
          {painPoints.map(point => <li key={point} className="flex gap-3 rounded-2xl border border-night-line bg-night p-4 sm:p-5" data-id="element-163" data-mp="3idbhm0ct6zii">
              <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-rust/15" data-id="element-164" data-mp="3nbmr29z6z807">
                <XIcon className="h-3.5 w-3.5 text-rust-soft" data-id="element-165" data-mp="1yykezhme9g2t" />
              </span>
              <span className="font-sans text-[0.95rem] leading-relaxed text-parchment/75" style={{
            fontSize: "18px",
            color: "#FAF8F5"
          }} data-id="element-166" data-mp="1u12d2b6so14b">
                {point}
              </span>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-gold-soft/40 bg-gold/10 px-6 py-7 text-center" style={{
        paddingTop: "20px",
        width: "328px",
        height: "212px"
      }} data-id="element-167" data-mp="23thxdf5kd1sd">
          <p className="font-display text-xl font-semibold text-gold-soft sm:text-2xl" style={{
          fontSize: "35px"
        }} data-id="element-168" data-mp="1b4aqnsvyh5w1">
            {painClaim}
          </p>
          <p className="mt-3 font-sans text-base leading-relaxed text-parchment/80" data-id="element-169" data-mp="1k34rjvgbkife">
            {painClose}
          </p>
        </div>
      </div>
    </section>;
}